import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "", innerClassName = "", inView = false }) => {
  const motionProps = inView
    ? {
        initial: { y: "112%" },
        whileInView: { y: 0 },
        viewport: { once: true, margin: "-40px" },
      }
    : { initial: { y: "112%" }, animate: { y: 0 } };
  return (
    <span className={`block overflow-hidden pb-[0.16em] -mb-[0.16em] ${className}`}>
      <motion.span
        {...motionProps}
        transition={{ duration: 1.05, delay, ease: EASE }}
        className={`block will-change-transform ${innerClassName}`}
      >
        {children}
      </motion.span>
    </span>
  );
};

export const SectionLabel = ({ index, title, dark = false }) => (
  <div
    className={`flex items-center gap-4 text-[11px] md:text-[13px] font-bold uppercase tracking-[0.2em] ${
      dark ? "text-white/60" : "text-black/60"
    }`}
  >
    <span className={`inline-block h-2 w-2 ${dark ? "bg-white" : "bg-black"}`} />
    <span data-testid={`section-label-${index}`}>
      {index} — {title}
    </span>
    <span className={`h-px flex-1 ${dark ? "bg-white/20" : "bg-black/20"}`} />
  </div>
);
